import React from "react"

const path = _ => (
  <path d="M10.578 31.354c-8.922-13.165-10.578-14.516-10.578-19.354 0-6.627 5.278-12 11.789-12s11.789 5.373 11.789 12c0 4.838-1.656 6.189-10.578 19.354-0.585 0.861-1.838 0.861-2.423 0zM11.789 17c2.713 0 4.912-2.239 4.912-5s-2.199-5-4.912-5c-2.713 0-4.912 2.239-4.912 5s2.199 5 4.912 5z"></path>
)

export default path
